import { ref } from 'vue';
// The Wrybit viewport owner sets these; importing a table does not change the document layout.
export const mobileLayout = ref(false);
export const mobileLandscape = ref(false);
